module.exports = __webpack_public_path__ + "static/media/cardchairpose.b3f8c3cf.jpg";